import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

const LoadingPage = () => {
  return (
    <Box
      sx={{
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 3,
        bgcolor: 'background.default'
      }}
    >
      <Typography variant="h3" component="h1" gutterBottom>
        OSCAR
      </Typography>
      <Typography variant="h5" color="textSecondary" gutterBottom>
        OpenSearch SSA Knowledge Base
      </Typography>
      <CircularProgress size={60} thickness={4} />
    </Box>
  );
};

export default LoadingPage;
